module.exports = __webpack_public_path__ + "static/media/home-technology-icon.43e6d80b.png";